import { defineComponent as _defineComponent } from 'vue'
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'

interface IProps {
  transparent?: string
  isOnlyIcon?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PatreonLabel',
  props: {
    transparent: { default: '80%' },
    isOnlyIcon: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true,BKSvgIcon }
}

})